
import { alertActions } from 'actions/alert.actions';
import AppHelper from 'helpers/AppHelper';
import RecipeService from 'services/recipe.services';
import { actions } from './actionTypes';

export const getListRecipes = (
  page: number,
  limit: number,
  search?: string
) => {
  return (dispatch: any) => {
    dispatch(actions.getListRecipes());
    RecipeService.getListRecipes({ page, limit, search })
      .then((res: any) => {
        dispatch(actions.getListRecipesSuccess(res?.data));
      })
      .catch((err) => {
        dispatch(actions.getListRecipesFail(err));
      });
  };
};

export const createRecipe = (params: any) => {
  return async (dispatch: any) => {
    dispatch(actions.createRecipe());
    return await RecipeService.createRecipe(params)
      .then((res: any) => {
        const itemsPerPage = 12;
        const page = 1;
        dispatch(actions.createRecipeSuccess(res?.data));
        dispatch(getListRecipes(page, itemsPerPage));
        dispatch(alertActions.success('Recipe has been created successfully'))
        return res.data;
      })
      .catch((err) => {
        dispatch(actions.createRecipeFail(err));
        dispatch(alertActions.error('Something happened please try again!'))
      });
  };
};

export const updateRecipe = (recipe_id: string, params: any) => {
  return async (dispatch: any) => {
    dispatch(actions.updateRecipe());
    return await RecipeService.updateRecipe(recipe_id, params)
      .then((res: any) => {
        dispatch(actions.updateRecipeSuccess(res?.data));
        // dispatch(alertActions.success(`Recipe [${params?.name}] has been edited successfully!`))
        return res.data;
      })
      .catch((err) => {
        dispatch(actions.updateRecipeFail(err));
        dispatch(alertActions.error('Something happened please try again!'))
      });
  };
};

export const getRecipeDetail = (recipe_id: string) => {
  return async (dispatch: any) => {
    dispatch(actions.getRecipeDetail());
    return await RecipeService.getRecipeDetail(recipe_id)
      .then((res: any) => {
        dispatch(actions.getRecipeDetailSuccess(res?.data));
        return res.data;
      })
      .catch((err) => {
        dispatch(actions.getRecipeDetailFail(err));
      });
  };
};

export const createInstruction = (recipe_id: string, params: any) => {
  return async (dispatch: any) => {
    dispatch(actions.createInstruction());
    return await RecipeService.createInstruction(recipe_id, params)
      .then((res: any) => {
        dispatch(actions.createInstructionSuccess(res?.data));
        return res.data;
      })
      .catch((err) => {
        dispatch(actions.createInstructionFail(err));
      });
  };
};

export const updateInstruction = (recipe_id: string, instruction_id: string, params: any) => {
  return async (dispatch: any) => {
    dispatch(actions.updateInstruction());
    return await RecipeService.updateInstruction(recipe_id, instruction_id, params)
      .then((res: any) => {
        dispatch(actions.updateInstructionSuccess(res?.data));
        return res.data;
      })
      .catch((err) => {
        dispatch(actions.updateInstructionFail(err));
      });
  };
};

export const orderInstruction = (recipe_id: string, params: any) => {
  return async (dispatch: any) => {
    dispatch(actions.orderInstruction());
    return await RecipeService.orderInstruction(recipe_id, params)
      .then((res: any) => {
        dispatch(actions.orderInstructionSuccess(res?.data));
        return res.data;
      })
      .catch((err) => {
        dispatch(actions.orderInstructionFail(err));
      });
  };
};

export const deleteInstruction = (recipe_id: string, instruction_id: string) => {
  return async (dispatch: any) => {
    dispatch(actions.deleteInstruction());
    return await RecipeService.deleteInstruction(recipe_id, instruction_id)
      .then((res: any) => {
        dispatch(actions.deleteInstructionSuccess(res?.data));
        return res.data;
      })
      .catch((err) => {
        dispatch(actions.deleteInstructionFail(err));
      });
  };
};

export const createIngredient = (recipe_id: string, params: any) => {
  return async (dispatch: any) => {
    dispatch(actions.createIngredient());
    return await RecipeService.createIngredient(recipe_id, params)
      .then((res: any) => {
        dispatch(actions.createIngredientSuccess(res?.data));
        return res.data;
      })
      .catch((err) => {
        dispatch(actions.createIngredientFail(err));
      });
  };
};

export const updateIngredient = (recipe_id: string, ingredient_id: string, params: any) => {
  return async (dispatch: any) => {
    dispatch(actions.updateIngredient());
    return await RecipeService.updateIngredient(recipe_id, ingredient_id, params)
      .then((res: any) => {
        dispatch(actions.updateIngredientSuccess(res?.data));
        return res.data;
      })
      .catch((err) => {
        dispatch(actions.updateIngredientFail(err));
      });
  };
};

export const orderIngredient = (recipe_id: string, params: any) => {
  return async (dispatch: any) => {
    dispatch(actions.orderIngredient());
    return await RecipeService.orderIngredient(recipe_id, params)
      .then((res: any) => {
        dispatch(actions.orderIngredientSuccess(res?.data));
        return res.data;
      })
      .catch((err) => {
        dispatch(actions.orderIngredientFail(err));
      });
  };
};

export const deleteIngredient = (recipe_id: string, ingredient_id: string) => {
  return async (dispatch: any) => {
    dispatch(actions.deleteIngredient());
    return await RecipeService.deleteIngredient(recipe_id, ingredient_id)
      .then((res: any) => {
        dispatch(actions.deleteIngredientSuccess(res?.data));
        return res.data;
      })
      .catch((err) => {
        dispatch(actions.deleteIngredientFail(err));
      });
  };
};

export const deleteRecipe = (id?: any) => {
  return async (dispatch: any) => {
    dispatch(actions.deleteRecipe());
    return await RecipeService.deleteRecipe(id)
      .then((res: any) => {
        dispatch(actions.deleteRecipeSuccess({id}));
        dispatch(alertActions.success('Recipe has been deleted successfully!'));
      })
      .catch((err) => {
        dispatch(actions.deleteRecipeFail(err));
        dispatch(alertActions.error('Error'));
      });
  };
};

export const deleteImageRecipe = (id?: any) => {
  return async (dispatch: any) => {
    dispatch(actions.deleteImageRecipe());
    return await RecipeService.deleteImageRecipe(id)
      .then((res: any) => {
        dispatch(actions.deleteImageRecipeSuccess({id}));
      })
      .catch((err) => {
        dispatch(actions.deleteImageRecipeFail(err));
      });
  };
};